import { style } from '@vanilla-extract/css'

const nav = style({
  position: 'sticky',
  top: 0,
  left: 0,
  right: 0,
  width: '100%',
  height: '60px',
  zIndex: 10000,
})

const header = style({
  backgroundColor: 'white',
  boxShadow: '0px 8px 16px 0px #C5C5C50D',
  width: '100%',
  height: '100%',
})

const headerContent = style({
  position: 'relative',
  height: '60px',
  width: '100%',
})

const backdrop = style({
  opacity: 0,
  pointerEvents: 'none',
  position: 'fixed',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  zIndex: -1,
  'selectors': {
    [`${nav}:has(input:checked) &`]: {
      pointerEvents: 'auto',
    },
  },
})

const logo = style({
  height: '25px',
})

const navToggle = style({
  position: 'absolute',
  top: '8px',
  right: '24px',
  width: '56px',
  padding: '12px 16px',
  display: 'block',
  cursor: 'pointer',
  WebkitTouchCallout: 'none',
  userSelect: 'none',
})

const navContent = style({
  position: 'relative',
  zIndex: -1,
  transform: 'translateY(-200%)',
  transition: 'transform 0.2s ease-in-out',
  'selectors': {
    [`${nav}:has(input:checked) &`]: {
      transform: 'translateY(0)',
    },
  },
})

const links = style({
  backgroundColor: 'white',
  padding: '16px 0',
})

const link = style({
  display: 'inline-block',
  padding: '8px 24px',
  fontFamily: 'Inter Variable, sans-serif',
  fontSize: '19px',
  fontWeight: '700',
  lineHeight: '1.5',
  textDecoration: 'none',
  width: '100%',
})

export const styles = {
  nav,
  header,
  headerContent,
  backdrop,
  logo,
  navToggle,
  navContent,
  links,
  link,
}
